module.exports = __webpack_public_path__ + "img/jr-logo.796305d2.svg";